import React, { FC } from 'react';
import NotificationActionWrapper from '../NotificationActionWrapper';
import HyperLink from '../../common/HyperLink';
import SeparatorWithText from '../../common/SeperatorWithText';
import ManageAllNotificationPreference from '../ManageAllNotificationPreference';

interface WorkOrderNotificationSuccessCardProps {
	workOrderId: number;
	successTitle: string;
	revertElement: any;
	onReverseAction: () => void;
}

const WorkOrderNotificationSuccessCard: FC<WorkOrderNotificationSuccessCardProps> = ({
	successTitle,
	revertElement,
	workOrderId,
	onReverseAction,
}): React.ReactElement => {
	return (
		<NotificationActionWrapper>
			<div className="h2medium ">{successTitle}</div>
			<div className="h5regular">{revertElement}</div>
			<div className="bodyregular flex flex-row flex-nowrap gap-2">
				Made a mistake? Restore your subscription{' '}
				<HyperLink text="here" onClick={onReverseAction} />
			</div>
			<SeparatorWithText className="mt-4" text="OR" />
			<ManageAllNotificationPreference />
		</NotificationActionWrapper>
	);
};

export default WorkOrderNotificationSuccessCard;
